<template>
    <div class="chat__item" :id="chatItem.id" :class="[ chatItem.sender ? 'chat__item--sender' : '', chatItem.reacted ? 'chat__item--reacted' : '', chatItem.status === -1 ? 'chat__item--deleted' : '' ]">

      <!-- Avatar -->
      <div v-if="!chatItem.sender" class="chat__item__avatar">
        <img v-if="isValidIcon(getAvatar(chatItem.userid))" v-bind:src="buildAvatarPath(getAvatar(chatItem.userid), 300)">
      </div>

        <!-- Content -->
        <div class="chat__item__content" style="user-select: none;">

         	  <!-- Content: Image (Erstmal nicht) -->
            <!--<img class="chat__item__image" src="../assets/whitelabel/header-bg-mobile.png">--->

            <!-- Content: Ticker -->
            <!--<div class="chat__item__ticker">
              <div class="chat__item__ticker__match">
                <img src="../../assets/jerseys/bundesliga1/72/jersey_leverkusen.png" alt="">
                B04
                <div class="chat__item__ticker__match__result">
                  2:1
                </div>
                BOC
                <img src="../../assets/jerseys/bundesliga1/72/jersey_bochum.png" alt="">
              </div>
              <div class="chat__item__ticker__text">
                <img src="../../assets/icons/ic_liveticker_tor.svg">
                <div class="chat__item__ticker__text__content">
                  <div class="chat__item__ticker__text__title">
                    Tor für Leverkusen! (2:1)
                  </div>
                  <div class="chat__item__ticker__text__subtitle">
                    Granit Xhaka · 89. Minute
                  </div>
                </div>
              </div>
            </div>-->

            <!-- Content: Text -->
          	<div class="chat__item__message">

           		<!-- Title -->
             	<div v-if="chatItem.sender" v-on:click="itemClicked" class="chat__item__message__title">
             		<div class="chat__item__message__title__username">
                  Ich ({{ chatItem.username }})
                </div>
            		<span>{{ chatItem.time | formatTimeChat }}</span>
            		<div v-if="chatItem.status !== -1" v-on:click="itemClicked" class="chat__item__message__title__actions">
            		</div>
             	</div>
             	<div v-else v-on:click="itemClicked" class="chat__item__message__title">
             		<div class="chat__item__message__title__username">
                  {{ chatItem.username }}
                </div>
             		<span>{{ chatItem.time | formatTimeChat }}</span>
             		<div v-if="chatItem.status !== -1" v-on:click="itemClicked" class="chat__item__message__title__actions">
          			</div>
             	</div>

              <!-- Optional: Answer -->
              <ChatAnswer v-if="chatItem.in_response_to_message && chatItem.in_response_to_message._id" :key="chatItem.in_response_to_message._id" 
                          :username="chatItem.in_response_to_message.username" :text="chatItem.in_response_to_message.text" 
                          @answerClicked="answerClicked"></ChatAnswer>
              
             	<!-- Nachricht -->
             	<p v-on:click="itemClicked">{{ chatItem.text }}</p>
              
              <!-- Optional: Reactions -->
             	<div v-if="chatItem && chatItem.reactions && chatItem.reactions.length > 0 && chatItem.status !== -1" class="chat__item__message__reactions">

              		<!-- Reaction Item -->
              		<div v-for="r in reactionsSorted" v-on:click="reactionClicked(r)" class="chat__item__message__reactions__item">
                     	<span>{{ r.text }}</span>{{ r.count }}
                  </div>

                </div>
          	</div>
        </div>

    </div>
</template>

<script>
  import ChatAnswer from '../../components/chat/ChatAnswer'

	export default {
    name: 'ChatItem',
    components: { ChatAnswer },
    props: {
      chatItem: Object,
    },
  	data () {
			return {}
  	},
  	beforeCreate () {
  	},
  	methods: {
        answerClicked() {
          this.$emit('answerClicked', { id: this.chatItem.in_response_to_message._id })
        },
        reactionClicked(reaction) {
          this.$emit('reactionClicked', { reaction: reaction })
        },
    		itemClicked() {
      		this.$emit('itemClicked', {})
    		},
        includeCount(list, item) {
          var count = 0
          for (let i = 0; i < list.length; i++) {
            if(list[i].text === item) {
              count++
            }
          }
          return count
        }
  	},
  	computed: {
      reactionsSorted() {
        const sorted = []
        const temp = this.chatItem.reactions
        for (let i = 0; i < temp.length; i++) {
          if(this.includeCount(sorted, temp[i].text) > 0) {
            sorted.filter((item) => {
              if(item.text === temp[i].text) {
                item.count++
              }
            })
          } else {
            sorted.push({'text': temp[i].text, 'count': 1})
          }
        }
        return sorted
      }
    }
	}
</script>

<style lang="scss">
  .chat__item {
      display: flex;
      align-items: flex-end;
      margin-bottom: 20px;
      width: calc(100% - 48px);

      /* Styling for Chat Item, which has been sent from active user */
      &--sender {
        flex-direction: row-reverse;
        margin-left: auto;
        width: calc(100% - 80px);
      }

      &--reacted {
        margin-bottom: 20px;
      }

      &__avatar {
        position: relative;
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 8px;
        overflow: hidden;
        background: rgba($colorGreyDark, .08);

        &:before {
          position: absolute;
          z-index: -1;
          top: 8px;
          left: 8px;
          width: 16px;
          height: 16px;
          content: url('../../assets/chat/ic_16_user.svg');
          opacity: .48;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      &__content {
        display: flex;
        flex-direction: column;
        flex: 1;
        width: calc(100% - 48px);

        > div, img {
          &:not(:last-child) {
            margin-bottom: 4px;
            border-radius: 8px 8px 4px 4px;

            ~ div { 
              border-radius: 4px 4px 8px 4px;
            }
          }
        }
      }

      &__image {
        border-radius: 8px 8px 8px 4px;
        width: 100%;
        max-height: 250px;
        object-fit: contain;
        background: rgba($colorGreyDark, .12);
        transition: all .2s ease-in-out;

        &:hover {
          cursor: pointer;
          background: rgba($colorGreyDark, .2);
        }
      }

      &__message {
        background: $colorWhite;
        border-radius: 8px 8px 8px 4px;
        padding: 13px 16px 10px;

        .chat__item--sender & {
          background: var(--color-primary);
        }

        .chat__item--deleted & {
          background: rgba($colorGreyDark, .12);
        }

        &__title {
          display: flex;
          margin-bottom: 3px;
          color: $colorGreyDark;

          .chat__item--sender & {
            color: $colorWhite;
          }

          .chat__item--deleted & {
            color: rgba($colorGreyDark, .64);
          }

          &__username {
            font-size: 14px;
            line-height: 20px;
            font-weight: 500;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-right: 4px;
          }

          span {
            font-size: 11px;
            line-height: 20px;
            font-weight: 400;
            opacity: .48;
            margin-left: auto;
          }

          &__actions {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 16px;
            margin: -18px -16px -16px -12px;
            cursor: pointer;

            &:hover {
             span {
              background: $colorGreyDark;

              .chat__item--sender & {
               background: $colorWhite;
              }
             }
            }

            span {
             width: 2.5px;
             height: 2.5px;
             border-radius: 50%;
             background: rgba($colorGreyDark, .32);
             margin: 0 .75px;
          opacity: 1;
             transition: all .2s ease-in-out;

             .chat__item--sender & {
              background: rgba($colorWhite, .48);
        }
            }
          }
        }

        p {
          font-size: 16px;
          line-height: 22px;
          font-weight: 400;
          color: $colorGreyDark;
          word-break: break-word;

          .chat__item--sender & {
            color: $colorWhite;
          }

          .chat__item--deleted & {
            color: rgba($colorGreyDark, .64);
            font-style: italic;
          }
        }

        small {
          text-align: left;
          justify-content: flex-start;
          padding: 0 0 2px;
          margin-top: -4px;
        }

        &__reactions {
          margin: 8px 0 -22px;

          &__item {
            display: inline-flex;
            align-items: center;
            background: $colorWhite;
            box-shadow: inset 0 0 0 1px rgba($colorGreyDark, .12), 0 4px 16px rgba($colorGreyDark, 0);
            font-size: 11px;
            line-height: 0;
            font-weight: 500;
            color: $colorGreyDark;
            padding: 13px 12px 11px 6px;
            border-radius: 12px;
            transition: all .2s ease-in-out;

            &:not(:last-child) {
              margin-right: 4px;
            }

            &:hover {
              box-shadow: inset 0 0 0 1px rgba($colorGreyDark, .24), 0 4px 16px rgba($colorGreyDark, .04);
              transform: translateY(-2px);
              cursor: pointer;
            }

            span {
              font-size: 14px;
              margin-right: 6px;
            }
          }
        }

        .chat__item--scrolledto & {
          animation: scrolledtoanimation 2.5s forwards;
        }

        @keyframes scrolledtoanimation {
          0% {
            box-shadow: 0 0 0 1px rgba($colorPrimary, .48);
            transform: scale(1);
          }
          5% {
            box-shadow: 0 0 0 1px rgba($colorPrimary, .48);
            transform: scale(1);
          }
          15% {
            box-shadow: 0 0 0 1px rgba($colorPrimary, .48);
            transform: scale(1.05);
          }
          25% {
            box-shadow: 0 0 0 1px rgba($colorPrimary, .48);
            transform: scale(1);
          }
          50% {
            box-shadow: 0 0 0 1px rgba($colorPrimary, .48);
            transform: scale(1);
          }
          100% {
            box-shadow: 0 0 0 1px rgba($colorPrimary, 0);
            transform: scale(1);
          }
        }
      }

      &__ticker {

        &__match {
          display: flex;
          justify-content: center;
          align-items: center;
          background: $colorWhite;
          border-radius: 8px 8px 0 0;
          padding: 12px 16px;
          font-size: 14px;
          color: $colorGreyDark;
          margin-bottom: 1px;

          img {
            width: 32px;
            height: 32px;
            border-radius: 0 !important;
            margin: 0 8px 0 0 !important;

            &:last-child {
              margin: 0 0 0 8px !important;
            }
          }

          &__result {
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            margin: auto;
            font-size: 20px;
            font-weight: 500;
            letter-spacing: 2px;

            /*span {
              font-size: 10px;
              color: $colorLive;
              letter-spacing: 0;
            }*/
          }
        }

        &__text {
          display: flex;
          align-items: center;
          background: $colorWhite;
          border-radius: 0 0 8px 4px;
          padding: 12px 16px;

          img {
            margin-right: 12px;
          }

          &__content {
            display: flex;
            flex-direction: column;
          }

          &__title {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 500;
            color: $colorGreyDark;

            img {
              margin-right: 6px;
            }
          }

          &__subtitle {
            font-size: 11px;
            color: rgba($colorGreyDark, .64);
            margin-top: 2px;
          }
        }
      }
    }
</style>
